module.exports = __webpack_public_path__ + "img/TULSK.71b737f4.png";